import React from 'react';

import { useParams } from 'react-router';

import { MotivoDevolucaoFormComp, MotivoDevolucaoListComp } from './components';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function MotivoDevolucaoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['FINANCEIRO_DEVOLUCAO_MOTIVO_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <MotivoDevolucaoListComp />
        </ListagemProvider>
    );
}

export function MotivoDevolucaoForm() {
    const { hasFormPermission, alertNotPermission } = usePermissionsContext();
    const { id } = useParams();

    if (!hasFormPermission('FINANCEIRO_DEVOLUCAO_MOTIVO', id)) return alertNotPermission();

    return (
        <FormProvider>
            <MotivoDevolucaoFormComp />
        </FormProvider>
    );
}
